export async function createLead(client, body) {
  return await client.createLead(body);
}
